/* Bow Buddy — Design Your Own logo mockup tool
   Self-contained. Mount: <div class="bbd" data-bbd='{...config}'> ... </div>  */
(function () {
  'use strict';

  function lum(r, g, b) { return 0.2126 * r + 0.7152 * g + 0.0722 * b; }
  function hexToRgb(h) { h = (h || '#000').replace('#', ''); if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join(''); var n = parseInt(h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function rgbToHex(r, g, b) { return '#' + [r, g, b].map(function (v) { v = Math.max(0, Math.min(255, Math.round(v))); return (v < 16 ? '0' : '') + v.toString(16); }).join('').toUpperCase(); }
  function normHex(h) { h = String(h || '').trim().replace(/^#?/, '#'); if (/^#[0-9a-f]{3}$/i.test(h)) h = '#' + h[1] + h[1] + h[2] + h[2] + h[3] + h[3]; return /^#[0-9a-f]{6}$/i.test(h) ? h.toUpperCase() : null; }
  function hsvToRgb(h, s, v) { var f = function (n) { var k = (n + h / 60) % 6; return v - v * s * Math.max(0, Math.min(k, 4 - k, 1)); }; return [f(5) * 255, f(3) * 255, f(1) * 255]; }
  function rgbToHsv(r, g, b) { r /= 255; g /= 255; b /= 255; var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn, h = 0; if (d) { if (mx === r) h = ((g - b) / d) % 6; else if (mx === g) h = (b - r) / d + 2; else h = (r - g) / d + 4; h *= 60; if (h < 0) h += 360; } return [h, mx ? d / mx : 0, mx]; }
  function loadImg(src) {
    // Try with CORS first (keeps "Download" working); fall back to a plain load so the preview still shows.
    function attempt(cors) {
      return new Promise(function (res, rej) {
        var i = new Image();
        if (cors) i.crossOrigin = 'anonymous';
        i.onload = function () { res(i); }; i.onerror = rej; i.src = src;
      });
    }
    if (/^(blob:|data:)/.test(src)) return attempt(false);
    return attempt(true).catch(function () { return attempt(false); });
  }

  function Designer(root) {
    this.root = root;
    this.cfg = JSON.parse(root.getAttribute('data-bbd') || '{}');
    this.canvas = root.querySelector('[data-bbd-canvas]');
    this.ctx = this.canvas.getContext('2d');
    this.state = { color: 0, mode: 'logo', scale: 0.85, cx: 0.5, cy: 0.5, showArea: true, knockout: true, ink: 'original', text: '', font: this.cfg.fonts ? this.cfg.fonts[0].value : 'Impact', textColor: '#ffffff', customHex: (this.cfg.customDefault || '#1E73BE'), hsv: [0, 0, 1] };
    this.cache = {};
    this.logoSrc = null; this.design = null;
    this.init();
  }

  Designer.prototype.q = function (s) { return this.root.querySelector(s); };
  Designer.prototype.qa = function (s) { return Array.prototype.slice.call(this.root.querySelectorAll(s)); };

  Designer.prototype.init = function () {
    var self = this, c = this.cfg;
    var first = c.colors[0];
    loadImg(first.image || c.base).then(function (img) {
      self.base = img;
      self.canvas.width = img.naturalWidth; self.canvas.height = img.naturalHeight;
      var W = img.naturalWidth, H = img.naturalHeight;
      var aw = W * c.area.w / 100, ah = aw * (c.area.mmH / c.area.mmW);
      self.area = { x: W * c.area.cx / 100 - aw / 2, y: H * c.area.cy / 100 - ah / 2, w: aw, h: ah };
      self.prepareMask();
      self.root.classList.add('is-ready');
      self.draw();
    });
    this.bindUI();
    this.bindPicker();
  };

  /* ---------- Unit color engine: recolor the black product photo to any color ---------- */
  Designer.prototype.prepareMask = function () {
    var W = this.base.naturalWidth, H = this.base.naturalHeight;
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var x = cv.getContext('2d'); x.drawImage(this.base, 0, 0);
    try { this.baseData = x.getImageData(0, 0, W, H); } catch (e) { this.baseData = null; return; }
    var p = this.baseData.data, idx = [], ks = [], ls = [];
    for (var i = 0, n = 0; i < p.length; i += 4, n++) {
      var L = lum(p[i], p[i + 1], p[i + 2]);
      if (L > 120) continue;                                   // background + soft shadow stay put
      idx.push(i); ks.push(L < 95 ? 1 : (120 - L) / 25); ls.push(L);
    }
    this.mask = { idx: Uint32Array.from(idx), k: Float32Array.from(ks), L: Float32Array.from(ls) };
  };

  Designer.prototype.tint = function (hex, reuse) {
    if (!this.mask || !this.baseData) return this.base;
    var key = 't' + hex;
    if (!reuse && this.cache[key]) return this.cache[key];
    var W = this.base.naturalWidth, H = this.base.naturalHeight;
    var cv = reuse ? (this.customCv || (this.customCv = document.createElement('canvas'))) : document.createElement('canvas');
    cv.width = W; cv.height = H;
    var x = cv.getContext('2d');
    var out = reuse && this.customData ? this.customData : x.createImageData(W, H);
    if (reuse) this.customData = out;
    var o = out.data, src = this.baseData.data, m = this.mask, t = hexToRgb(hex);
    o.set(src);
    for (var j = 0; j < m.idx.length; j++) {
      var i = m.idx[j], k = m.k[j], Ln = m.L[j] / 90;
      var shade = 0.38 + Ln * 0.85, spec = Ln > 0.8 ? (Ln - 0.8) * 110 : 0;
      o[i] = src[i] * (1 - k) + Math.min(255, t[0] * shade + spec) * k;
      o[i + 1] = src[i + 1] * (1 - k) + Math.min(255, t[1] * shade + spec) * k;
      o[i + 2] = src[i + 2] * (1 - k) + Math.min(255, t[2] * shade + spec) * k;
    }
    x.putImageData(out, 0, 0);
    if (!reuse) this.cache[key] = cv;
    return cv;
  };

  Designer.prototype.colorName = function () {
    var s = this.state;
    return s.color === 'custom' ? 'Custom ' + s.customHex : this.cfg.colors[s.color].name;
  };
  Designer.prototype.colorHex = function () {
    var s = this.state;
    return s.color === 'custom' ? s.customHex : (this.cfg.colors[s.color].tint || this.cfg.colors[s.color].swatch || '').toUpperCase();
  };

  Designer.prototype.baseFor = function () {
    var self = this, s = this.state;
    if (s.color === 'custom') return Promise.resolve(this.tint(s.customHex, true));
    var col = this.cfg.colors[s.color], key = 'img' + s.color;
    if (col.image) {
      if (this.cache[key]) return Promise.resolve(this.cache[key]);
      return loadImg(col.image).then(function (i) { self.cache[key] = i; return i; });
    }
    if (!col.tint) return Promise.resolve(this.base);
    return Promise.resolve(this.tint(col.tint));
  };

  Designer.prototype.requestDraw = function () {
    var self = this;
    if (this._raf) return;
    this._raf = requestAnimationFrame(function () { self._raf = null; self.draw(); });
  };

  /* ---------- Logo processing: trim, knock out white, one-color ink ---------- */
  Designer.prototype.buildLogo = function () {
    if (!this.logoSrc) { this.design = null; return; }
    var img = this.logoSrc, s = this.state;
    var max = 1600, r = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    var w = Math.round(img.naturalWidth * r), h = Math.round(img.naturalHeight * r);
    var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
    var x = cv.getContext('2d'); x.drawImage(img, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h), p = d.data;
    var ink = s.ink === 'white' ? [255, 255, 255] : s.ink === 'black' ? [12, 12, 12] : s.ink === 'green' ? hexToRgb('#9bea1f') : null;
    var minX = w, minY = h, maxX = 0, maxY = 0;
    for (var i = 0, n = 0; i < p.length; i += 4, n++) {
      var L = lum(p[i], p[i + 1], p[i + 2]);
      if (s.knockout && L > 225) p[i + 3] = Math.round(p[i + 3] * Math.max(0, (250 - L) / 25));
      if (ink && p[i + 3] > 0) {
        if (!s.knockout && L > 235) { p[i + 3] = 0; }
        p[i] = ink[0]; p[i + 1] = ink[1]; p[i + 2] = ink[2];
      }
      if (p[i + 3] > 16) { var px = n % w, py = (n / w) | 0; if (px < minX) minX = px; if (px > maxX) maxX = px; if (py < minY) minY = py; if (py > maxY) maxY = py; }
    }
    x.putImageData(d, 0, 0);
    if (maxX <= minX || maxY <= minY) { this.design = cv; return; }
    var out = document.createElement('canvas'); out.width = maxX - minX + 1; out.height = maxY - minY + 1;
    out.getContext('2d').drawImage(cv, minX, minY, out.width, out.height, 0, 0, out.width, out.height);
    this.design = out;
  };

  Designer.prototype.buildText = function () {
    var s = this.state, t = (s.text || '').trim();
    if (!t) { this.design = null; return; }
    var size = 220, cv = document.createElement('canvas'), x = cv.getContext('2d');
    var font = '700 ' + size + 'px ' + s.font;
    x.font = font; var m = x.measureText(t);
    cv.width = Math.ceil(m.width + 40); cv.height = Math.ceil(size * 1.25);
    x = cv.getContext('2d'); x.font = font; x.textBaseline = 'middle'; x.textAlign = 'center';
    x.fillStyle = s.textColor; x.fillText(t, cv.width / 2, cv.height / 2);
    // trim
    var d = x.getImageData(0, 0, cv.width, cv.height).data, minX = cv.width, minY = cv.height, maxX = 0, maxY = 0;
    for (var i = 3, n = 0; i < d.length; i += 4, n++) if (d[i] > 16) { var px = n % cv.width, py = (n / cv.width) | 0; if (px < minX) minX = px; if (px > maxX) maxX = px; if (py < minY) minY = py; if (py > maxY) maxY = py; }
    var out = document.createElement('canvas'); out.width = Math.max(1, maxX - minX + 1); out.height = Math.max(1, maxY - minY + 1);
    out.getContext('2d').drawImage(cv, minX, minY, out.width, out.height, 0, 0, out.width, out.height);
    this.design = out;
  };

  Designer.prototype.rebuild = function () {
    if (this.state.mode === 'text') this.buildText(); else this.buildLogo();
    this.updateFit(); this.draw();
  };

  /* ---------- Geometry ---------- */
  Designer.prototype.designRect = function () {
    if (!this.design || !this.area) return null;
    var a = this.area, d = this.design, s = this.state;
    var fit = Math.min(a.w / d.width, a.h / d.height);
    var w = d.width * fit * s.scale, h = d.height * fit * s.scale;
    var cx = a.x + w / 2 + (a.w - w) * s.cx, cy = a.y + h / 2 + (a.h - h) * s.cy;
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h };
  };

  Designer.prototype.updateFit = function () {
    var el = this.q('[data-bbd-fit]'); if (!el) return;
    var r = this.designRect(), c = this.cfg.area;
    if (!r) { el.textContent = 'Print area: ' + c.mmW + ' × ' + c.mmH + ' mm'; el.className = 'bbd__fit'; return; }
    var mmW = (r.w / this.area.w * c.mmW).toFixed(1), mmH = (r.h / this.area.h * c.mmH).toFixed(1);
    var ratio = this.design.width / this.design.height;
    var tall = ratio < 4;
    el.textContent = 'Printed size ≈ ' + mmW + ' × ' + mmH + ' mm' + (tall ? ' — tip: wide, horizontal logos print largest' : '');
    el.className = 'bbd__fit' + (tall ? ' is-warn' : ' is-ok');
  };

  /* ---------- Render ---------- */
  Designer.prototype.draw = function (forExport) {
    var self = this;
    if (!this.base) return Promise.resolve();
    return this.baseFor().then(function (base) {
      var x = self.ctx, W = self.canvas.width, H = self.canvas.height, a = self.area;
      x.clearRect(0, 0, W, H);
      x.fillStyle = '#fff'; x.fillRect(0, 0, W, H);
      x.drawImage(base, 0, 0, W, H);
      var r = self.designRect();
      if (r) {
        // compose the print on its own layer, then let a little of the plastic's texture show through the ink
        var L = self.layer || (self.layer = document.createElement('canvas'));
        L.width = Math.ceil(a.w); L.height = Math.ceil(a.h);
        var lx = L.getContext('2d');
        lx.clearRect(0, 0, L.width, L.height);
        lx.drawImage(self.design, r.x - a.x, r.y - a.y, r.w, r.h);
        lx.globalCompositeOperation = 'source-atop'; lx.globalAlpha = 0.14;
        lx.drawImage(base, a.x, a.y, a.w, a.h, 0, 0, L.width, L.height);
        lx.globalCompositeOperation = 'source-over'; lx.globalAlpha = 1;
        x.save(); x.globalAlpha = 0.97; x.drawImage(L, a.x, a.y); x.restore();
      }
      if (!forExport && self.state.showArea) {
        x.save(); x.setLineDash([10, 8]); x.lineWidth = 2;
        x.strokeStyle = 'rgba(155,234,31,.95)'; x.strokeRect(a.x, a.y, a.w, a.h);
        var label = 'PRINT AREA ' + self.cfg.area.mmW + ' × ' + self.cfg.area.mmH + ' MM';
        x.setLineDash([]); x.font = '700 17px ' + (self.cfg.labelFont || 'sans-serif');
        var tw = x.measureText(label).width;
        x.fillStyle = 'rgba(14,16,12,.88)'; x.fillRect(a.x, a.y - 34, tw + 20, 26);
        x.fillStyle = '#9bea1f'; x.fillText(label, a.x + 10, a.y - 15);
        x.restore();
      }
      if (forExport) {
        x.save(); x.font = '600 22px sans-serif'; x.fillStyle = 'rgba(14,16,12,.55)'; x.textAlign = 'right';
        x.fillText((self.cfg.watermark || 'Bow Buddy® custom mockup') + ' · ' + self.colorName(), W - 32, H - 32);
        x.restore();
      }
    });
  };

  /* ---------- UI ---------- */
  Designer.prototype.bindUI = function () {
    var self = this, s = this.state;

    this.qa('[data-bbd-color]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.qa('[data-bbd-color]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        var v = b.getAttribute('data-bbd-color');
        s.color = v === 'custom' ? 'custom' : +v;
        var pk = self.q('[data-bbd-picker]'); if (pk) pk.hidden = s.color !== 'custom';
        if (s.color === 'custom') self.renderWheel();
        self.updateColorLabel();
        self.draw();
      });
    });

    this.qa('[data-bbd-tab]').forEach(function (b) {
      b.addEventListener('click', function () {
        s.mode = b.getAttribute('data-bbd-tab');
        self.qa('[data-bbd-tab]').forEach(function (o) { o.setAttribute('aria-selected', o === b ? 'true' : 'false'); });
        self.qa('[data-bbd-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-bbd-panel') !== s.mode; });
        self.rebuild();
      });
    });

    var file = this.q('[data-bbd-file]'), drop = this.q('[data-bbd-drop]');
    function take(f) {
      if (!f || !/^image\//.test(f.type)) return;
      var url = URL.createObjectURL(f);
      loadImg(url).then(function (img) {
        self.logoSrc = img; s.scale = 0.85; s.cx = 0.5; s.cy = 0.5;
        var sl = self.q('[data-bbd-scale]'); if (sl) sl.value = 85;
        var nm = self.q('[data-bbd-filename]'); if (nm) nm.textContent = f.name;
        self.root.classList.add('has-design');
        self.rebuild();
      });
    }
    if (file) file.addEventListener('change', function () { take(file.files[0]); });
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (e) { drop.addEventListener(e, function (ev) { ev.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (e) { drop.addEventListener(e, function (ev) { ev.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (ev) { take(ev.dataTransfer.files[0]); });
    }

    var ko = this.q('[data-bbd-knockout]'); if (ko) ko.addEventListener('change', function () { s.knockout = ko.checked; self.rebuild(); });
    this.qa('[data-bbd-ink]').forEach(function (b) {
      b.addEventListener('click', function () {
        s.ink = b.getAttribute('data-bbd-ink');
        self.qa('[data-bbd-ink]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        self.rebuild();
      });
    });

    var txt = this.q('[data-bbd-text]'); if (txt) txt.addEventListener('input', function () { s.text = txt.value; self.root.classList.toggle('has-design', !!txt.value.trim()); self.rebuild(); });
    var font = this.q('[data-bbd-font]'); if (font) font.addEventListener('change', function () { s.font = font.value; self.rebuild(); });
    this.qa('[data-bbd-textcolor]').forEach(function (b) {
      b.addEventListener('click', function () {
        s.textColor = b.getAttribute('data-bbd-textcolor');
        self.qa('[data-bbd-textcolor]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        self.rebuild();
      });
    });

    var sl = this.q('[data-bbd-scale]'); if (sl) sl.addEventListener('input', function () { s.scale = sl.value / 100; self.updateFit(); self.draw(); });
    var ctr = this.q('[data-bbd-center]'); if (ctr) ctr.addEventListener('click', function () { s.cx = 0.5; s.cy = 0.5; self.draw(); });
    var sa = this.q('[data-bbd-showarea]'); if (sa) sa.addEventListener('change', function () { s.showArea = sa.checked; self.draw(); });

    var dl = this.q('[data-bbd-download]');
    if (dl) dl.addEventListener('click', function () {
      self.draw(true).then(function () {
        try {
          var a = document.createElement('a');
          a.download = 'bow-buddy-mockup-' + self.colorName().toLowerCase().replace(/[^a-z0-9]+/g, '-') + '.png';
          a.href = self.canvas.toDataURL('image/png');
          document.body.appendChild(a); a.click(); a.remove();
        } catch (e) { alert('Download is blocked by your browser. Take a screenshot instead.'); }
        self.draw();
      });
    });

    // drag to position (pointer events: mouse, touch, pen)
    var dragging = false, start = null;
    function pt(ev) { var r = self.canvas.getBoundingClientRect(); return { x: (ev.clientX - r.left) * self.canvas.width / r.width, y: (ev.clientY - r.top) * self.canvas.height / r.height }; }
    this.canvas.addEventListener('pointerdown', function (ev) {
      var r = self.designRect(); if (!r) return; var p = pt(ev);
      var pad = 30;
      if (p.x < r.x - pad || p.x > r.x + r.w + pad || p.y < r.y - pad || p.y > r.y + r.h + pad) return;
      dragging = true; start = { p: p, cx: s.cx, cy: s.cy, r: r };
      self.canvas.setPointerCapture(ev.pointerId); self.canvas.classList.add('is-dragging'); ev.preventDefault();
    });
    this.canvas.addEventListener('pointermove', function (ev) {
      var p = pt(ev), r = self.designRect();
      self.canvas.style.cursor = r && p.x > r.x && p.x < r.x + r.w && p.y > r.y - 20 && p.y < r.y + r.h + 20 ? 'grab' : 'default';
      if (!dragging) return;
      var a = self.area, sw = a.w - start.r.w, sh = a.h - start.r.h;
      if (sw > 0) s.cx = Math.min(1, Math.max(0, start.cx + (p.x - start.p.x) / sw));
      if (sh > 0) s.cy = Math.min(1, Math.max(0, start.cy + (p.y - start.p.y) / sh));
      self.draw();
    });
    function end() { dragging = false; self.canvas.classList.remove('is-dragging'); }
    this.canvas.addEventListener('pointerup', end); this.canvas.addEventListener('pointercancel', end);

    // keyboard nudge for accessibility
    this.canvas.addEventListener('keydown', function (ev) {
      var step = ev.shiftKey ? 0.1 : 0.02, k = ev.key;
      if (k === 'ArrowLeft') s.cx = Math.max(0, s.cx - step); else if (k === 'ArrowRight') s.cx = Math.min(1, s.cx + step);
      else if (k === 'ArrowUp') s.cy = Math.max(0, s.cy - step); else if (k === 'ArrowDown') s.cy = Math.min(1, s.cy + step); else return;
      ev.preventDefault(); self.draw();
    });
  };

  Designer.prototype.updateColorLabel = function () {
    var lbl = this.q('[data-bbd-color-name]'); if (lbl) lbl.textContent = this.colorName();
    var chip = this.q('[data-bbd-chip]'); if (chip) chip.style.background = this.state.customHex;
    var cs = this.q('[data-bbd-color="custom"]'); if (cs && this.state.color === 'custom') cs.style.setProperty('--sw', this.state.customHex);
  };

  /* ---------- Color wheel (hue = angle, saturation = distance, brightness = slider) ---------- */
  Designer.prototype.renderWheel = function () {
    var cv = this.q('[data-bbd-wheel]'); if (!cv) return;
    var x = cv.getContext('2d'), S = cv.width, R = S / 2, v = this.state.hsv[2];
    if (this._wheelV === v) return this.placeDot();
    this._wheelV = v;
    var img = x.createImageData(S, S), d = img.data;
    for (var y = 0; y < S; y++) for (var xx = 0; xx < S; xx++) {
      var dx = xx - R + 0.5, dy = y - R + 0.5, r = Math.sqrt(dx * dx + dy * dy), i = (y * S + xx) * 4;
      if (r > R) { d[i + 3] = 0; continue; }
      var h = (Math.atan2(dy, dx) * 180 / Math.PI + 360) % 360, c = hsvToRgb(h, Math.min(1, r / (R - 1)), v);
      d[i] = c[0]; d[i + 1] = c[1]; d[i + 2] = c[2]; d[i + 3] = r > R - 1 ? (R - r) * 255 : 255;
    }
    x.putImageData(img, 0, 0);
    this.placeDot();
  };
  Designer.prototype.placeDot = function () {
    var dot = this.q('[data-bbd-dot]'); if (!dot) return;
    var h = this.state.hsv[0] * Math.PI / 180, sat = this.state.hsv[1];
    dot.style.left = (50 + Math.cos(h) * sat * 50) + '%';
    dot.style.top = (50 + Math.sin(h) * sat * 50) + '%';
    dot.style.background = this.state.customHex;
  };
  Designer.prototype.setCustom = function (hex, fromHsv) {
    var s = this.state;
    s.customHex = hex;
    if (!fromHsv) { var c = hexToRgb(hex); s.hsv = rgbToHsv(c[0], c[1], c[2]); var br = this.q('[data-bbd-bright]'); if (br) br.value = Math.round(s.hsv[2] * 100); }
    var hx = this.q('[data-bbd-hex]'); if (hx && document.activeElement !== hx) hx.value = hex;
    if (s.color !== 'custom') {
      s.color = 'custom';
      this.qa('[data-bbd-color]').forEach(function (o) { o.setAttribute('aria-pressed', o.getAttribute('data-bbd-color') === 'custom' ? 'true' : 'false'); });
    }
    this.renderWheel(); this.updateColorLabel(); this.requestDraw();
  };
  Designer.prototype.bindPicker = function () {
    var self = this, s = this.state, wheel = this.q('[data-bbd-wheel]');
    if (!wheel) return;
    var c0 = hexToRgb(s.customHex); s.hsv = rgbToHsv(c0[0], c0[1], c0[2]);
    var br = this.q('[data-bbd-bright]'); if (br) br.value = Math.round(s.hsv[2] * 100);
    var hx = this.q('[data-bbd-hex]'); if (hx) hx.value = s.customHex;
    var wrap = wheel.parentElement, drag = false;
    function pick(ev) {
      var r = wheel.getBoundingClientRect(), R = r.width / 2;
      var dx = ev.clientX - r.left - R, dy = ev.clientY - r.top - R;
      var sat = Math.min(1, Math.sqrt(dx * dx + dy * dy) / R), h = (Math.atan2(dy, dx) * 180 / Math.PI + 360) % 360;
      s.hsv = [h, sat, s.hsv[2] || 1];
      var c = hsvToRgb(h, sat, s.hsv[2]);
      self.setCustom(rgbToHex(c[0], c[1], c[2]), true);
    }
    wrap.addEventListener('pointerdown', function (ev) { drag = true; wrap.setPointerCapture(ev.pointerId); pick(ev); ev.preventDefault(); });
    wrap.addEventListener('pointermove', function (ev) { if (drag) pick(ev); });
    wrap.addEventListener('pointerup', function () { drag = false; });
    wrap.addEventListener('pointercancel', function () { drag = false; });
    wrap.addEventListener('keydown', function (ev) {
      var h = s.hsv[0], sat = s.hsv[1];
      if (ev.key === 'ArrowLeft') h = (h + 355) % 360; else if (ev.key === 'ArrowRight') h = (h + 5) % 360;
      else if (ev.key === 'ArrowUp') sat = Math.min(1, sat + 0.05); else if (ev.key === 'ArrowDown') sat = Math.max(0, sat - 0.05); else return;
      ev.preventDefault(); s.hsv = [h, sat, s.hsv[2]]; var c = hsvToRgb(h, sat, s.hsv[2]); self.setCustom(rgbToHex(c[0], c[1], c[2]), true);
    });
    if (br) br.addEventListener('input', function () {
      s.hsv = [s.hsv[0], s.hsv[1], br.value / 100];
      var c = hsvToRgb(s.hsv[0], s.hsv[1], s.hsv[2]); self.setCustom(rgbToHex(c[0], c[1], c[2]), true);
    });
    if (hx) {
      hx.addEventListener('input', function () { var h = normHex(hx.value); hx.classList.toggle('is-bad', !h && hx.value.length > 3); if (h) self.setCustom(h); });
      hx.addEventListener('blur', function () { hx.value = s.customHex; hx.classList.remove('is-bad'); });
    }
    this.qa('[data-bbd-quick]').forEach(function (b) { b.addEventListener('click', function () { self.setCustom(normHex(b.getAttribute('data-bbd-quick'))); }); });
    var eye = this.q('[data-bbd-eyedrop]');
    if (eye) {
      if (!('EyeDropper' in window)) eye.hidden = true;
      else eye.addEventListener('click', function () { new window.EyeDropper().open().then(function (r) { var h = normHex(r.sRGBHex); if (h) self.setCustom(h); }).catch(function () {}); });
    }

    var cp = this.q('[data-bbd-copy]');
    if (cp) cp.addEventListener('click', function () {
      var r = self.designRect(), a = self.cfg.area, lines = ['Bow Buddy custom order'];
      lines.push('Unit color: ' + self.colorName() + (s.color === 'custom' ? '' : ' (' + self.colorHex() + ')'));
      if (s.mode === 'text') lines.push('Text: "' + (s.text || '') + '" · ' + (self.q('[data-bbd-font] option:checked') || {}).textContent + ' · ' + s.textColor.toUpperCase());
      else { var fn = self.q('[data-bbd-filename]'); lines.push('Logo: ' + (self.logoSrc && fn ? fn.textContent : 'not uploaded') + ' · Ink: ' + ({original: 'Full color', white: 'White', black: 'Black', green: 'BB Green'}[s.ink] || s.ink)); }
      if (r) lines.push('Printed size ≈ ' + (r.w / self.area.w * a.mmW).toFixed(1) + ' × ' + (r.h / self.area.h * a.mmH).toFixed(1) + ' mm (print area ' + a.mmW + ' × ' + a.mmH + ' mm)');
      var txt = lines.join('\n');
      var done = function () { var o = cp.textContent; cp.textContent = 'Copied ✓'; setTimeout(function () { cp.textContent = o; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done, function () { window.prompt('Copy your specs:', txt); });
      else window.prompt('Copy your specs:', txt);
    });
  };

  function boot(scope) {
    (scope || document).querySelectorAll('.bbd[data-bbd]').forEach(function (el) {
      if (el.__bbd) return; el.__bbd = new Designer(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  window.BowBuddyDesigner = { boot: boot };
})();
